import React from 'react';
import { Input } from './Input';

interface DatePickerProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  min?: string;
  max?: string;
  required?: boolean;
  disabled?: boolean;
}

export const DatePicker: React.FC<DatePickerProps> = ({ label, value, onChange, min, max, required, disabled }) => {
  return (
    <Input
      label={label}
      type="date"
      value={value || ''}
      onChange={e => onChange?.(e.target.value)}
      min={min}
      max={max}
      required={required}
      disabled={disabled}
    />
  );
};
